module.exports = __webpack_public_path__ + "media/images/robot_astronauta_mail-1ef30684bec5c62348c16a7fee60ced6.svg";